module.exports = __webpack_public_path__ + "static/media/snowball_war_montage.5cd436a8.jpg";